import React, { useContext, useEffect, useState } from "react";
import { Button, Container, Form, Spinner, Modal } from "react-bootstrap";
import AlertComponent from "../../components/AlertComponent";
import axios from "axios";
import { UserContext } from "../page_listen";
import { errorState, initialState } from "../../components/enum";
import { languagePayment, methodPayment } from "./json";
import TabCode from "./TabCode";

const TabPayment = ({ idLanguage }) => {
  const id = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(initialState);
  const [namePayment, setNamePayment] = useState("Cash");
  const [textLang, setTextLang] = useState([]);
  const [showModalPassword, setModalPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [disabileButton, setDisableButton] = useState(true);
  const [img, setImg] = useState("/static/base_images/cuori.png");

  useEffect(() => {
    const lang = languagePayment.filter((el) => el.id === (id || idLanguage));
    setTextLang(lang);
  }, []);

  const handlePayment = () => {
    setError(initialState);
    setLoading(true);
    axios
      .get(`creategatewaylink?id=${String(id || idLanguage)}&email=${email}`)
      .then((res) => {
        setTimeout(function () {
          document.location.href = res.data.Message;
        }, 250);
        setLoading(false);
      })
      .catch(() => {
        setError(errorState);
        setLoading(false);
      });
  };

  useEffect(() => {
    const modal = document.getElementById("modalListenForPassword")
      .parentElement.classList;
    if (showModalPassword) {
      modal.remove("show");
    } else {
      modal.add("show");
    }
  }, [showModalPassword]);

  const showModal = () => {
    setModalPassword(!showModalPassword);
  };

  const sendEmail = (e) => {
    const regex = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;
    setEmail(e.target.value);
    if (regex.test(e.target.value)) {
      setDisableButton(false);
    } else {
      setDisableButton(true);
    }
  };

  return (
    <>
      <Modal show={showModalPassword}>
        <Modal.Body>
          <TabCode
            idLanguage={idLanguage}
            title={"Password"}
            button={"Enter"}
          />
        </Modal.Body>
        <Modal.Footer>
          <div className={"row"}>
            <div className={"col-9"}>
              <p className={"text-center font-elv bold font-small"}>
                {textLang[0]?.information}
              </p>
            </div>
            <div className={"col-3 m-auto text-center"}>
              <Button className="buttons__close" onClick={() => showModal()}>
                Close
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
      <div className="py-2">
        <p className="h4 text-center font-elv">
          {textLang[0]?.text}
          <p className={"h4 text-center font-elv bold"}>{textLang[0]?.euro}</p>
        </p>

        <br />
        <p className="h4 text-center font-elv">{textLang[0]?.payChoice}</p>
        <p className="font-small text-center font-elv">{textLang[0]?.durata}</p>
      </div>
      <div id="buttonContainer" className="d-flex justify-content-center my-2">
        <Button
          className="w-auto d-flex gap-2 align-items-center justify-content-center"
          disabled={
            namePayment === "Cash" ? loading : loading || disabileButton
          }
          onClick={
            namePayment === "Cash" ? () => showModal() : () => handlePayment()
          }
        >
          {loading && <Spinner size="sm" animation="border" />}
          <span className={"font-elv bold"}>{`${
            textLang[0]?.paywith + " " + namePayment
          }`}</span>
        </Button>
      </div>
      <Container className="d-flex justify-content-center">
        <Form
          id="formMethodPayment"
          style={{ width: "fit-content" }}
          className="d-flex flex-column"
        >
          <div style={{ padding: "5px" }} className="row d-flex">
            <div className={"col-6 d-flex align-items-center p-0"}>
              <Form.Check
                name="method"
                style={{ paddingRight: "20px" }}
                type="radio"
                onChange={() => setNamePayment("Cash")}
                defaultChecked
              />
              <div style={{ textAlign: "left" }}>
                <span className="h4 font-elv" style={{ fontWeight: "bold" }}>
                  {textLang[0]?.cash}
                </span>
                <br />
                <span className="font-elv">{textLang[0]?.shop}</span>
              </div>
            </div>
            <div className={"col-6"}>
              <img id="images_heart" src={img} height={"80"} />
            </div>
          </div>

          <div className={"row"}>
            {methodPayment.map((el, index) => (
              <div className={"col-6 d-flex align-items-center"} key={index}>
                <div className={"row"}>
                  <div
                    style={{ padding: "5px", height: "70px" }}
                    className=" col-12 d-flex align-items-center"
                  >
                    <Form.Check
                      name="method"
                      style={{ paddingRight: "20px" }}
                      type="radio"
                      onChange={() => setNamePayment(el.description)}
                    />
                    <img src={el.image} height={el.height || "30"} />
                  </div>
                  {el.description === namePayment && (
                    <div className={"px-2"}>
                      <Form.Control
                        onChange={sendEmail}
                        placeholder={textLang[0]?.email}
                        className="col-12"
                        type="text"
                      ></Form.Control>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </Form>
      </Container>

      {error.showError ? (
        <AlertComponent message={error.message} type={error.type} />
      ) : (
        <></>
      )}
    </>
  );
};

export default TabPayment;
